"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRewardsPool__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "batchCollectEra",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "collect",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "collectEra",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "getReward",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "getUnclaimDeployments",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "",
                type: "bytes32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "labor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IRewardsPool__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IRewardsPool__factory = IRewardsPool__factory;
IRewardsPool__factory.abi = _abi;
